require('./loanMovementsTableRow.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const classNames = require('classnames');
// @ components
const { getLanguage } = require('core/i18n').i18n;
const { LabelDate } = require('commonsComponents/labelDate');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ constants
const ZERO_DESCRIPTION = 'DISP. PRESTAMO';
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');

class LoanMovementsTableRow extends React.Component {

    constructor(props) {
        super(props);

        this.handleRowClick = this.handleRowClick.bind(this);
    }

    handleRowClick() {
        const { id, onRowClick } = this.props;

        onRowClick(id);
    }

    render() {
        const { immTransaction, id, isExpanded } = this.props;
        const expandIconClass = classNames({
            'icon-accordion-abrir': !isExpanded,
            'icon-accordion-cerrar': isExpanded
        });
        const language = getLanguage();
        const amountShouldBeZero = immTransaction.get('description').indexOf(ZERO_DESCRIPTION) !== -1;
        const descriptionClass = classNames(
            'loan-movements-table-row__cell-description',
            {
                'loan-movements-table-row__text-highlighted': isExpanded
            }
        );
        const plainAmountCapitalObject = getPlainAmountObject(immTransaction.get('capital'));
        let amount, dropdownIcon;

        if (amountShouldBeZero) {
            amount = {
                currency: immTransaction.getIn(['amount', 'currency']),
                amount: 0
            }
        } else {
            amount = immTransaction.get('amount');
            dropdownIcon = (
                <OKButton
                    id="btnLoanMovementToggleDetails"
                    modifier="link-ghost"
                    onClick={this.handleRowClick}
                >
                    <i className={expandIconClass} />
                </OKButton>
            );
        }

        const plainAmountObject = getPlainAmountObject(amount);

        return (
            <OKTableRow id={id}>
                <OKTableCell className="loan-movements-table-row__cell-icon">
                    {dropdownIcon}
                </OKTableCell>
                <OKTableCell>
                    <LabelDate
                        date={immTransaction.get('movementDate')}
                        language={language}
                        today={LABEL_DATE_TODAY}
                        yesterday={LABEL_DATE_YESTERDAY}
                    />
                </OKTableCell>
                <OKTableCell>
                    <LabelDate
                        date={immTransaction.get('valueDate')}
                        language={language}
                        today={LABEL_DATE_TODAY}
                        yesterday={LABEL_DATE_YESTERDAY}
                    />
                </OKTableCell>
                <OKTableCell>
                    <p className={descriptionClass}>{immTransaction.get('description')}</p>
                </OKTableCell>
                <OKTableCell className="loan-movements-table-row__cell-fee-import">
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                </OKTableCell>
                <OKTableCell className="loan-movements-table-row__cell-pending-capital">
                    <OneLineSymbolAmount
                        amountObject={plainAmountCapitalObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountCapitalObject, true)} />
                </OKTableCell>
            </OKTableRow>
        );
    }
}

LoanMovementsTableRow.propTypes = {
    immTransaction: PropTypes.object,
    id: PropTypes.string,
    onRowClick: PropTypes.func,
    isExpanded: PropTypes.bool
};

LoanMovementsTableRow.defaultProps = {
    className: '',
    onRowClick: function () { }
};

module.exports = LoanMovementsTableRow;
